import { EnvSelector } from './env-selector/env-selector';

const FETCH = {
  'dev': {
    API_DOMAIN: 'https://scc-qa.usequantum.com.cn',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://scc-qa.usequantum.com.cn',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'qa': {
    API_DOMAIN: 'https://scc-qa.usequantum.com.cn',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://scc-qa.usequantum.com.cn',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'alpha': {
    API_DOMAIN: 'https://scc-alpha.usequantum.com.cn',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://scc-alpha.usequantum.com.cn',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'uat-china': {
    API_DOMAIN: 'http://ehscnq.app.swiretest.com',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://ehscnq.app.swiretest.com',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'uat-global': {
    API_DOMAIN: 'https://ehsq.app.swiretest.com',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://ehsq.app.swiretest.com',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'staging-china': {
    API_DOMAIN: 'https://ehscnb.app.swirecocacola.com',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://ehscnb.app.swirecocacola.com',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'staging-global': {
    API_DOMAIN: 'https://ehsb.app.swirecocacola.com',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://ehsb.app.swirecocacola.com',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'prod-china': {
    API_DOMAIN: 'https://ehscn.app.swirecocacola.com',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://ehscn.app.swirecocacola.com',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  },
  'prod-global': {
    API_DOMAIN: 'https://ehs.app.swirecocacola.com',
    API_DIR: '/facts_backend-2.6/rest',
    UPLOAD_URL: 'https://ehs.app.swirecocacola.com',
    IOS_VERSION: '0.1.3',
    ANDROID_VERSION: '0.1.3',
  }
};

let DEPLOY = '';

if (document.baseURI.toLowerCase().indexOf('localhost') !== -1) { // 本地或物理设备
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('android') !== -1    // 安卓
   || userAgent.indexOf('iphone') !== -1     // iPhone
   || userAgent.indexOf('ipad') !== -1       // iPad
   || userAgent.indexOf('mac os') !== -1) {  // Mac OS
    DEPLOY = FETCH[EnvSelector.env] ? EnvSelector.env : 'qa';
  } else { // 本地
    DEPLOY = 'qa';
  }
} else { // web端
  const a = document.baseURI.toLowerCase();
  if (a.indexOf('scc-app-dev') !== -1) { // dev
    DEPLOY = 'dev';
  } else if (a.indexOf('scc-qa-app') !== -1) { // qa
    DEPLOY = 'qa';
  } else if (a.indexOf('scc-alpha-app') !== -1) { // alpha
    DEPLOY = 'alpha';
  } else if (a.indexOf('ehscnq.app.swiretest.com') !== -1) { // China UAT
    DEPLOY = 'uat-china';
  } else if (a.indexOf('ehsq.app.swiretest.com') !== -1) { // Global UAT
    DEPLOY = 'uat-global';
  } else if (a.indexOf('ehscnb.app.swirecocacola.com') !== -1) { // China Staging
    DEPLOY = 'staging-china';
  } else if (a.indexOf('ehsb.app.swirecocacola.com') !== -1) { // Global Staging
    DEPLOY = 'staging-global';
  } else if (a.indexOf('ehscn.app.swirecocacola.com') !== -1) { // China Prod
    DEPLOY = 'prod-china';
  } else if (a.indexOf('ehs.app.swirecocacola.com') !== -1) { // Global Prod
    DEPLOY = 'prod-global';
  } else {
    DEPLOY = 'qa';
  }
}

export const APPConfig = FETCH[DEPLOY];

// 兜底：保证 API_DOMAIN/API_DIR/UPLOAD_URL 在任何 Angular 服务、组件构造之前就已经写入 localStorage。
// app.component.ts 的 initConfig() 原本是唯一写这几个key的地方，但它是在 AppComponent 构造函数里跑的，
// 晚于本模块（env.ts）的模块加载求值时机。像"扫码自动登录"这类一进页面就立刻发请求、几乎没有延迟的入口，
// 如果在 initConfig() 真正落地之前就有代码读取 localStorage 里的 API_DOMAIN/API_DIR（两者都是 null），
// "null + null" 在 JS 里会被当数字相加算成 0，拼出类似 "0/xxx" 这种非法的相对路径接口地址。
// 这里在模块求值这个最早的同步时机就把默认值写进去，从根上堵住这个时序缝隙。
const currentApiDomain = localStorage.getItem('API_DOMAIN');
if (!currentApiDomain || currentApiDomain === 'null') {
  localStorage.setItem('API_DOMAIN', APPConfig.API_DOMAIN);
  localStorage.setItem('API_DIR', APPConfig.API_DIR);
  localStorage.setItem('UPLOAD_URL', APPConfig.UPLOAD_URL);
}
